import Vue from 'vue'
import * as types from 'store/mutation-types'

function filterItems(data, id) {
  return data.filter(item => item.id === id)[0]
}

function normalizeSimpleObject(object) {
  if (!object) return
  const standardObj = {
    id: object.id,
    name: object.name,
    items: null
  }
  if (object.items) {
    standardObj.items = [...object.items]
  } else if (object.data) {
    standardObj.items = [...object.data]
  }
  return standardObj
}

function normalizeEtfObject(object) {
  if (!object) return
  const standardObj = {
    id: object.id,
    name: object.name,
    items: null
  }
  const newArray = object.data.map(val => {
    return {
      symbol: val[0],
      name: val[1],
      latestPrice: val[2],
      changeRate: val[3]
    }
  })
  standardObj.items = [...newArray]
  return standardObj
}

function normalizeSpecialObject(data, isPublished) {
  if (!data) return
  const standardObj = {
    id: data.id,
    name: data.name,
    published: isPublished,
    items: null
  }
  if (standardObj.published) {
    standardObj.id = standardObj.id + '_published'
  } else {
    standardObj.id = standardObj.id + '_unpublished'
  }
  const itemKey = isPublished ? 'published' : 'unpublished'

  if (data[itemKey]) {
    standardObj.name = standardObj.name + ' ' + data[itemKey].name
    standardObj.items = data[itemKey].items
  }
  return standardObj
}

function normalizeSpecialPackageObject(object) {
  if (!object) return
  const standardObj = {
    id: object.id,
    name: object.name,
    items: null
  }
  const newArray = object.data.map(val => {
    return {
      symbol: val[0],
      name: val[1],
      latestPrice: val[2],
      changeRate: val[3]
    }
  })
  standardObj.items = [...newArray]
  return standardObj
}

const actions = {
  loadUsTodayDiscovery({ commit, getters }, { market, category }) {
    const param = getters.discoveryFilter
    const list = pageId =>
      Vue.http
        .get(`~stock/market/page/${pageId}`, {
          params: { ...param.usUnFilter }
        })
        .then(resp => {
          if (resp.data.ret === 0) {
            return resp.data
          }
        })
    const unusualList = () =>
      Vue.http
        .get('~stock/explore/unusual', {
          params: { limit: 50, ...param.usUnFilter, includeHourTrading: true }
        })
        .then(resp => {
          if (resp.data.ret === 0) {
            return resp.data
          }
        })
    const hotList = () =>
      Vue.http
        .get('~stock/explore/hot', {
          params: { limit: 50 }
        })
        .then(resp => {
          if (resp.data.ret === 0) {
            return resp.data
          }
        })

    return Promise.all([
      list('top'),
      list('drop'),
      list('week52_new_high'),
      list('week52_new_low'),
      unusualList(),
      hotList()
    ]).then(([top, drop, week52High, week52Low, unusual, hot]) => {
      const changeRate5MinTop = filterItems(unusual.items, 'changeRate5MinTop')
      const changeRate5MinDrop = filterItems(
        unusual.items,
        'changeRate5MinDrop'
      )
      const hourTradingTop = filterItems(unusual.items, 'hourTradingTop')
      const hourTradingDrop = filterItems(unusual.items, 'hourTradingDrop')
      const volumeTop = filterItems(hot.items, 'volumeTop')
      const amountTop = filterItems(hot.items, 'amountTop')

      const payload = {
        market,
        category,
        top: normalizeSimpleObject(top),
        drop: normalizeSimpleObject(drop),
        week52High: normalizeSimpleObject(week52High),
        week52Low: normalizeSimpleObject(week52Low),
        changeRate5MinTop: normalizeSimpleObject(changeRate5MinTop),
        changeRate5MinDrop: normalizeSimpleObject(changeRate5MinDrop),
        hourTradingTop: normalizeSimpleObject(hourTradingTop),
        hourTradingDrop: normalizeSimpleObject(hourTradingDrop),
        volumeTop: normalizeSimpleObject(volumeTop),
        amountTop: normalizeSimpleObject(amountTop)
      }
      return commit(types.LOAD_DISCOVERY_DATA, payload)
    })
  },
  loadUsEtfDiscovery({ commit }, { market, category }) {
    // US ETF IDs
    // package_us_etf_index
    // package_us_etf_vix
    // package_us_etf_commodity
    // package_us_etf_industry
    // package_us_etf_foreign_exchange
    const usEtf = id =>
      Vue.http.get(`~stock/etf/ranking/${id}`).then(resp => {
        if (resp.data.ret === 0) {
          return resp.data
        }
      })

    return Promise.all([
      usEtf('package_us_etf_index'),
      usEtf('package_us_etf_vix'),
      usEtf('package_us_etf_commodity'),
      usEtf('package_us_etf_industry'),
      usEtf('package_us_etf_foreign_exchange')
    ]).then(([etfIndex, vix, commodity, industry, forex]) => {
      const payload = {
        market,
        category,
        etfIndex: normalizeEtfObject(etfIndex),
        vix: normalizeEtfObject(vix),
        commodity: normalizeEtfObject(commodity),
        industry: normalizeEtfObject(industry),
        forex: normalizeEtfObject(forex)
      }
      return commit(types.LOAD_DISCOVERY_DATA, payload)
    })
  },
  loadUsSpecialDiscovery({ commit }, { market, category }) {
    const list = pageId =>
      Vue.http.get(`~stock/market/page/${pageId}`).then(resp => {
        if (resp.data.ret === 0) {
          return resp.data
        }
      })
    /* PACKAGE IDS:
     * package_china
     * package_popular
     */
    const specialPackage = packageId =>
      Vue.http.get(`~stock/market/${packageId}`).then(resp => {
        if (resp.data.ret === 0) {
          return resp.data.topics[0]
        }
      })

    return Promise.all([
      list('earnings'),
      list('dividends'),
      specialPackage('package_china'),
      specialPackage('package_popular')
    ]).then(([earnings, dividends, packageChina, packagePopular]) => {
      const payload = {
        market,
        category,
        earningsPublished: normalizeSpecialObject(earnings, true),
        earningsUnpublished: normalizeSpecialObject(earnings, false),
        dividendsPublished: normalizeSpecialObject(dividends, true),
        dividendsUnpublished: normalizeSpecialObject(dividends, false),
        packageChina: normalizeSpecialPackageObject(packageChina),
        packagePopular: normalizeSpecialPackageObject(packagePopular)
      }
      return commit(types.LOAD_DISCOVERY_DATA, payload)
    })
  }
}

export default {
  actions
}
